import React from 'react';
import './App.css';
import Header from './components/Header';
import Navbar from './components/Navbar';
import Banner from './components/Banner';
import Home from './components/Home';
import QuemSomos from './components/QuemSomos';
import Produtos from './components/Produtos';
import Contato from './components/Contato';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Header />
      <Banner />
      <Home />
      <QuemSomos />
      <Produtos />
      <Contato />
      <WhatsAppButton />
    </div>
  );
}

export default App;
